import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/TimeKeeperEmployer/TimeKeeperEmployerModel';
import { RootState } from '../../../store';
import TimeKeeperEmployerForm from '../TimeKeeperEmployerForm/TimeKeeperEmployerForm';

const TimeKeeperEmployerModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxTimeKeeperEmployer = useSelector((state: RootState) => state.models.timeKeeperEmployer);

  return (
    <Modal
      title={!!reduxTimeKeeperEmployer.id ? 'Modifica' : 'Adauga'}
      open={reduxTimeKeeperEmployer.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <TimeKeeperEmployerForm />
    </Modal>
  );
};

export default TimeKeeperEmployerModal;
